import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { StoreExpenseActions } from './store-expense.actions';
import {
  StoreExpenseRemainResponse,
  StoreExpenseRequestListContent,
  StoreExpenseViewResponse
} from '../models/store-expense.model';

export const storeExpenseKey = 'storeExpense';

export interface StoreExpenseState {
  storeExpenseRemaining: StoreExpenseRemainResponse;
  storeExpenseRequestList: Pagination<StoreExpenseRequestListContent>;
  storeExpenseView: StoreExpenseViewResponse;
  storeExpenseSubmitResponse: any;
}

export const initialState: StoreExpenseState = {
  storeExpenseRemaining: null,
  storeExpenseRequestList: null,
  storeExpenseView: null,
  storeExpenseSubmitResponse: null
};

export const storeExpenseReducer = createReducer<StoreExpenseState>(
  initialState,
  on(StoreExpenseActions.storeExpenseRemainResponse, (state, { response }) => {
    return { ...state, storeExpenseRemaining: response };
  }),
  on(StoreExpenseActions.storeExpenseRequestListResponse, (state, { response }) => {
    return { ...state, storeExpenseRequestList: response };
  }),
  on(StoreExpenseActions.resetStoreExpenseRequestList, (state) => {
    return { ...state, storeExpenseRequestList: null };
  }),
  on(StoreExpenseActions.storeExpenseViewResponse, (state, { response }) => {
    return { ...state, storeExpenseView: response };
  }),
  on(StoreExpenseActions.resetStoreExpenseView, (state) => {
    return { ...state, storeExpenseView: null };
  }),
  on(StoreExpenseActions.storeExpenseSubmitResponse, (state, response) => {
    return { ...state, storeExpenseSubmitResponse: response.response };
  }),
  on(StoreExpenseActions.storeExpenseSubmitClear, (state) => {
    return { ...state, storeExpenseSubmitResponse: null };
  })
);
